// extracted by mini-css-extract-plugin
export default {"oddType":"styles_oddType__DN-Oi","label":"styles_label__mq3P-","select":"styles_select__JoaDy","option":"styles_option__KR+7x"};